"use client"
import { ComponentConfig } from "@measured/puck"
import { FindInputProps, RenderConfig } from "./RenderConfig"

export const FindInput: ComponentConfig<FindInputProps> = {
  label: "Find Input",
  fields: {
    placeholder: {
      label: "Input Placeholder",
      type: "text",
    },
    buttonText: {
      label: "Button Text",
      type: "text",
    },
  },
  defaultProps: {
    placeholder: "Search...",
    buttonText: "Find",
  },
  ...RenderConfig,
}
